<template>
    <div id="inner-auth-content" class="d-flex flex-column align-center justify-left" style="width: 450px">
        <div class="d-flex justify-center align-center">
            <h4 style="color: dimgrey">{{ $t('auth.preRegistration.title') }}</h4>
        </div>

        <div class="d-flex align-center flex-column mt-8">
            <span class="d-flex justify-center responsive-auth-font" style="color: darkgrey; width: 420px">
                {{ $t('auth.preRegistration.submitted') }}
            </span>
            <span class="d-flex justify-center responsive-auth-font" style="color: darkgrey; width: 420px">
                {{ $t('auth.preRegistration.emailSoon') }}
            </span>
        </div>

        <div class="responsive-auth-login-link">
            <span
                class="d-flex justify-left responsive-auth-font"
                style="color: darkgrey"
            >
                {{ $t('auth.preRegistration.backHome') }}

                <inertia-link class="no-underline" href="/">
                    &nbsp;{{ $t('auth.clickHere') }}</inertia-link
                >
            </span>
        </div>
    </div>
</template>

<script>
import AuthLayout from "../Layouts/AuthLayout";

export default {
    layout: AuthLayout,
};
</script>

<style scoped>
@media only screen and (min-width: 1025px) {
    #inner-auth-content {
        max-width: 350px;
    }
}
</style>
